module.exports = __webpack_public_path__ + "static/img/content8.370d25cc.png";